import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('pesticideLicensesCard');

    return {
        ACTIONS_LABEL: t('actionsLabel'),
        ADD_LICENSE: t('addLicense'),
        DELETE: t('delete'),
        DELETE_CONFIRM_CANCEL: t('deleteConfirmCancel'),
        DELETE_CONFIRM_LABEL: t('deleteConfirmLabel'),
        DELETE_CONFIRM_MESSAGE: t('deleteConfirmMessage'),
        DELETE_CONFIRM_TITLE: t('deleteConfirmTitle'),
        DELETE_ERROR: t('deleteError'),
        DELETE_SUCCESS: t('deleteSuccess'),
        EDIT: t('edit'),
        EMPTY_DESCRIPTION: t('emptyDescription'),
        EMPTY_HEADING: t('emptyHeading'),
        EXPIRATION_DATE: t('expirationDate'),
        EXPIRED: t('expired'),
        ISSUED_DATE: t('issuedDate'),
        LICENSE_NUMBER: t('licenseNumber'),
        LOAD_ERROR: t('loadError'),
        LOAD_MORE: t('loadMore'),
        STATE: t('state'),
        TABLE_LABEL: t('tableLabel'),
        TITLE: t('title')
    };
};

export default useTranslation;
